/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react'
import { FormApi } from 'final-form'
import { Form as FinalForm } from 'react-final-form'
import createDecorator from 'final-form-focus'
import Button from '@mui/material/Button'
import { validateRequired } from 'utils/validation'
import { MembershipLevelSelect } from 'components/MembershipLevelSelect'
import TextareaAutosize from 'components/TextareaAutosize/TextareaAutosize'
import { MembershipType } from '__generatedTypes__/globalTypes'
import { findOneAiFullLengthTest_findOneCasperFullLengthTest as AIFullLengthTest } from '__generatedTypes__/findOneAiFullLengthTest'
import * as responseTestsFormClasses from 'pagesNew/ResponseTests/Form/styles'

export type FormValues = {
  id: string
  title: string
  description: string
  membershipLevel: MembershipType
}

type Props = {
  test: AIFullLengthTest
  onSubmit: (input: FormValues, form: FormApi<FormValues>) => Promise<void>
}

const focusOnErrors = createDecorator<FormValues, Partial<FormValues>>()

const getInitialValues = (test: AIFullLengthTest): Partial<FormValues> => ({
  id: test.id,
  title: test.title,
  description: test.description,
  membershipLevel: test.membershipLevel,
})

export const Form = ({ test, onSubmit }: Props) => {
  const [submitting, setSubmitting] = useState(false)
  const [initialValues, setInitialValues] = useState(getInitialValues(test))

  useEffect(() => {
    setInitialValues(getInitialValues(test))
  }, [test])

  const handleSubmit = async (values: FormValues, form: FormApi<FormValues>) => {
    try {
      setSubmitting(true)
      await onSubmit(values, form)
    } catch (e) {
      console.error(e)
    }
    setSubmitting(false)
  }

  return (
    <FinalForm<FormValues>
      decorators={[focusOnErrors]}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, dirty }) => (
        <form onSubmit={handleSubmit} css={responseTestsFormClasses.block} data-testid="response-flt-form">
          <TextareaAutosize
            name="description"
            label="Description"
            placeholder="Enter Description"
            data-testid="description-input"
            css={responseTestsFormClasses.textArea}
          />
          <MembershipLevelSelect name="membershipLevel" validate={validateRequired} fullWidth />

          <Button color="blue" type="submit" size="large" disabled={!dirty || submitting}>
            Save Edits
          </Button>
        </form>
      )}
    />
  )
}
